import intl from 'react-intl-universal'
import dayjs from 'dayjs'
import { useState, useEffect, useCallback, useMemo } from 'react'
import { Button, CascadePicker } from 'antd-mobile'
import { AddOutline } from 'antd-mobile-icons'
import { useSelector, useDispatch } from 'react-redux'
import { setBookingOption, selectBookingOption ,selectOwnBookingRule} from '../../../store/reducers/hotel'
import { formatJSON } from '../../../utils'


// 选项项组件
const OptionItem = ({ item, isActive, onClick, showWeekday = false, index, cls = '' }) => (
    <li
        className={`res_item ${isActive ? 'active' : ''} ${cls}`}
        onClick={onClick}
        key={index}
    >
        <div>
            {
                showWeekday && item.month && (
                    <div className='month'><small>{item.month}</small></div>
                )
            }
            <span className='bold-name' style={showWeekday ? { fontSize: 20 } : null}>{item.label}</span>
            {showWeekday && item.weekday && (
                <div><small>{item.weekday}</small></div>
            )}
            {item.ampm && (
                <div style={{ color: item.ampm === 'AM' ? '#fac28c' : '#a4a8d4' }}><small>{item.ampm}</small></div>
            )}
        </div>
    </li>
)

const BookOption = ({ handleNext, openTime = '11:00', closeTime = '23:00', isShow, dates, children, productInfo, merchantInfo, totalQuantity, productRule, from }) => {
    const [timeArray, setTimeArray] = useState([])
    const [peopleArray, setPeopleArray] = useState([])
    const [dateArray, setDateArray] = useState([])
    const [customTimeVisible, setCustomTimeVisible] = useState(false)

    const dispatch = useDispatch()
    const bookingOption = useSelector(selectBookingOption)
    const ownBookingRule = useSelector(selectOwnBookingRule)
    console.log(ownBookingRule, '////=====////ownBookingRule/////')

    const isAttrDisabled = () => {
        if (!productInfo) {
            return false
        }

        return false
    }


    const getExtendObj = useCallback(() => {
        /*
        if (productInfo) {
            const { extendColumn = '' } = productInfo || {}
            const extendObj = formatJSON(extendColumn)
            return extendObj
        } else {
            const { extendColumn1 = '' } = merchantInfo || {}
            const extendObj = formatJSON(extendColumn1) || {}
            const bookingRule = extendObj.bookingRule || {}
            return {
                ...bookingRule,
                peopleSetType: extendObj.peopleSetType,
                peopleNum: extendObj.peopleNum,
            }
        }
        */

        const productExtendObj = getProductExtendObj() || {}
        const merchantExtendObj = getMerchantExtendObj() || {}

        return {
            selTimeType: ownBookingRule?.selTimeType || productExtendObj.selTimeType || merchantExtendObj.selTimeType,
            peopleSetType: productExtendObj.peopleSetType || merchantExtendObj.peopleSetType,
            peopleNum: productExtendObj.peopleNum || merchantExtendObj.peopleNum,
        }

    }, [productInfo, merchantInfo])

    const getProductExtendObj = useCallback(() => {
        // console.log(productRule, '////=====////productRule/////')
        const { extendColumn = '' } = productInfo || {}
        const extendObj = formatJSON(extendColumn)
        return productRule || extendObj
    }, [productInfo, productRule])

    const getMerchantExtendObj = useCallback(() => {
        const { extendColumn1 = '' } = merchantInfo || {}
        const extendObj = formatJSON(extendColumn1) || {}
        const bookingRule = extendObj.bookingRule || {}
        return {
            ...bookingRule,
            peopleSetType: extendObj.peopleSetType,
            peopleNum: extendObj.peopleNum,
        }
    }, [merchantInfo])

    const extendObj = getExtendObj()
    const { selTimeType = 1, peopleNum = 0, peopleSetType = 1 } = extendObj || {}
    // console.log(extendObj, '///===extendObj==///')

    const isBookingDisabled = () => {
        // console.log('isBookingDisabled=========================')
        //selTimeType 1: 自定义时间，2: 无需选择 3: 自由选择时间
        const timeDisabled = (selTimeType === 1 || selTimeType === 3) && !selectedTime

        const peopleDisabled = peopleSetType !== 1 && !selectedPeople && peopleArray.length > 0

        return peopleDisabled || !selectedDate || timeDisabled || isAttrDisabled()
    }

    // 生成人数选项
    const genPeopleNums = useCallback(() => {
        let num = peopleNum || 0
        if (peopleSetType === 3) {
            num = totalQuantity > 1 ? totalQuantity : productInfo?.quantity
        }
        return Array.from({ length: num }, (_, index) => ({
            // label: intl.get('h_n_people', { num: index + 1 }),
            label: index + 1,
            value: index + 1
        }))
    }, [peopleNum, peopleSetType, productInfo, totalQuantity])

    // 生成日期选项
    const getDateColumns = useCallback((dates) => {
        const dateArray = []
        for (const date in dates) {
            const isToday = dayjs(date).isSame(dayjs(), 'day')
            const isTomorrow = dayjs(date).isSame(dayjs().add(1, 'day'), 'day')

            console.log(dayjs(date).format('D'), dayjs(date).format('MMMM'))

            const day = dayjs(date).format('D')
            const month = dayjs(date).format('MMM')

            const label = isToday ? intl.get('h_today', '今天') : isTomorrow ? intl.get('s_tomorrow', '明天') : null//dayjs(date).format(FORMAT)
            //if (dates[date].length > 0) {
            dateArray.push({
                month,
                label: day,
                value: date,
                weekday: label || dayjs(date).format('ddd'),
                date: date,
                list: dates[date] || []
            })
            //}
        }

        return dateArray

    }, [])

    // 处理日期点击
    const handleDateClick = useCallback((item) => {
        const { list = [] } = item
        if (selTimeType === 1 && list.length === 0) {
            return
        }
        const date = dayjs(item.date).format('YYYY-MM-DD')
        dispatch(setBookingOption({
            ...bookingOption,
            selectedDate: { ...item, date },
            selectedTime:null
        }))

        setTimeArray(list)
        /*
        // 更新时间选项
        setTimeArray(genBookingTime({
            curDate: date,
            openTime,
            closeTime
        }));
        //*/
    }, [dispatch, bookingOption, selTimeType]);

    // 处理人数选择
    const handlePeopleClick = useCallback((people) => {
        dispatch(setBookingOption({
            ...bookingOption,
            selectedPeople: people
        }))
    }, [dispatch, bookingOption]);

    // 处理时间选择
    const handleTimeClick = useCallback((time) => {
        dispatch(setBookingOption({
            ...bookingOption,
            selectedTime: time
        }))
    }, [dispatch, bookingOption]);

    // 初始化数据`
    useEffect(() => {
        console.log(peopleSetType, '////=====////peopleSetType/////', productInfo)
        const dateArray = getDateColumns(dates)
        const defaultTime = dateArray[0]?.list || []
        setDateArray(dateArray)
        setTimeArray(defaultTime);
        if (peopleSetType !== 1) {
            setPeopleArray(genPeopleNums())
        }
    }, [getDateColumns, genPeopleNums, openTime, closeTime, dates, peopleSetType, productInfo])

    // 提取选中的选项信息
    const { selectedPeople, selectedDate, selectedTime } = bookingOption

    // 计算显示的选项文本
    const optionsText = useMemo(() => {
        const peopleLabel = selectedPeople?.label;
        const dateLabel = selectedDate?.label;
        const month = selectedDate?.month;
        const dateStr = dateLabel && month ? `${dateLabel} ${month}` : undefined;
        const timeLabel = selectedTime ? `(${selectedTime?.label || ''} ${selectedTime?.ampm || ''})` : '';

        return [peopleLabel, dateStr, timeLabel]
            .filter(item => item !== undefined)
            .join(' · ');
    }, [selectedPeople, selectedDate, selectedTime]);

    const renderTime = () => {
        if (selTimeType === 1) {
            return <>
                <div className='step-title'>
                    {intl.get('h_time').d('Time')}
                </div>
                <ul className='res_items_box small-item-box jm-flex m-t-sm'>
                    {
                        timeArray.length > 0 ?
                            <>
                                {timeArray.map((time, index) => (
                                    <OptionItem
                                        key={index}
                                        index={index}
                                        item={time}
                                        isActive={selectedTime?.value === time.value}
                                        onClick={() => handleTimeClick(time)}
                                        cls='small-item'
                                    />
                                ))}
                            </>
                            :
                            <>
                                <div className='p10 fs-12'> {intl.get('h_no_time').d('暂无时间')}</div>
                            </>
                    }
                </ul>
                <br />
            </>
        } else if (selTimeType === 3) {
            return <>
                <div className='step-title'>
                    {intl.get('aaa').d('Time')}
                </div>
                <ul className='res_items_box small-item-box jm-flex m-t-sm'>
                    <li
                        className={`res_item small-item ${selectedTime?.label ? 'active' : ''}`}
                        onClick={() => {
                            setCustomTimeVisible(true)
                        }}
                    >
                        <div style={{ width: '100%' }}> {selectedTime?.label || <AddOutline />} </div>
                    </li>
                </ul>
            </>
        }

        return null
    }

    const handleCustomTimeConfirm = (items) => {
        const timeStr = items.join(':')
        dispatch(setBookingOption({
            ...bookingOption,
            selectedTime: { label: timeStr, value: timeStr }
        }))
        setCustomTimeVisible(false)
    }


    return (
        <div className='table-option step-wrapper bg-white' style={{ display: isShow ? 'block' : 'none' }}>
            {children}
            <div className='tb-detail-content'>
                <div className='step-title'>
                    {intl.get('h_date').d('Date')}
                </div>
                <ul className='res_items_box jm-flex m-t-sm'>
                    {
                        dateArray.length > 0
                            ?
                            <>
                                {dateArray.map((date, index) => (
                                    <OptionItem
                                        key={index}
                                        index={index}
                                        item={date}
                                        isActive={selectedDate?.value === date.value}
                                        onClick={() => handleDateClick(date)}
                                        showWeekday={true}
                                        cls={(selTimeType === 1 && date.list.length === 0) ? 'disabled' : ''}
                                    />
                                ))}
                            </>
                            :
                            <>
                                <div className='p10 fs-12'> {intl.get('h_no_time').d('暂无日期')}</div>
                            </>
                    }

                </ul>
                <br />
                {
                    peopleSetType !== 1 && peopleArray.length > 0 && (
                        <>
                            <div className='step-title'>
                                {intl.get('person_num').d('Number of people')}
                            </div>
                            <ul className='res_items_box small-item-box m-t-sm'>
                                {peopleArray.map((people, index) => (
                                    <OptionItem
                                        key={index}
                                        index={index}
                                        item={people}
                                        isActive={selectedPeople?.value === people.value}
                                        onClick={() => handlePeopleClick(people)}
                                        cls='small-item'
                                    />
                                ))}
                            </ul>
                            <br />
                        </>
                    )
                }

                {renderTime()}
                <br />


            </div>
            <div className='tb-ft-view'>
                <div className='tb-ft-btn-bar jm-flex'>
                    <div className='jm-flex-item'>
                        <b className='hide'>{optionsText}</b>
                    </div>
                    <div>
                        <Button
                            block
                            color='primary'
                            onClick={handleNext}
                            disabled={isBookingDisabled()}
                        >
                            {(productInfo?.type === 2 || from === 'spa') ? intl.get('h_request').d('Request') : intl.get('h_book').d('Book')}
                        </Button>
                    </div>
                </div>
            </div>
            <CascadePicker
                visible={customTimeVisible}
                onClose={() => setCustomTimeVisible(false)}
                options={timeArray}
                onConfirm={handleCustomTimeConfirm}
            />
        </div>
    )
}

export default BookOption